import { useState as u, useEffect as c, useMemo as o } from "react";
import { isInternalNode as p } from "./index.es76.js";
const l = (e, r) => {
  const [n, d] = u(e.childrenExpanded || !1);
  c(() => {
    d(e.childrenExpanded || !!r);
  }, [r, e.childrenExpanded]);
  const t = o(() => p(e) ? e.children.reduce((i, s) => s.isHidden ? i : i + 1, 0) : 0, [e]);
  return { isExpanded: n, setIsExpanded: d, visibleChildrenCount: t };
};
export {
  l as useTreeNode
};
//# sourceMappingURL=index.es5570.js.map
